import { gql } from '@apollo/client'

export const GET_PMIX_MENU_ITEM_NAMES = gql`
  query GetPmixMenuItemNames {
    getPmixMenuItemNames {
      nodes
    }
  }
`
